import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Modal, InputGroup, FormControl,
} from 'react-bootstrap';
import { buildSuccessStatus, buildFailureStatus, } from '../constants/AlertConstants';
import Confirm from '../confirm/Confirm';
import FieldSet from '../fieldset/FieldSet';
import BraintreePaymentService from '../../service/BraintreePaymentService';
import TransactionService from '../../service/TransactionService';
import UtilitiesService from '../../service/UtilitiesService';

class ChargebackTransactionForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      emailAddress: null,
    };
  }

  onStateChange(fieldName, value) {
    const update = {};
    update[fieldName] = value;
    this.setState(update);
  }

  onDismiss() {
    this.setState({
      status: null,
      chargebackStatus: null,
    });
  }

  showChargebackTransactionForm = () => {
    const { transactionId, externalId, } = this.props;
    const {
      isCreateChargebackConfirm = false,
      isLoading = false,
    } = this.state;

    const handleClose = () => {
      this.setState({
        isCreateChargebackConfirm: false,
        status: null,
      });
    };

    const handleOpen = () => {
      this.setState({
        isCreateChargebackConfirm: true,
        status: null,
      });
    };

    return (
      <div>
        <FieldSet title="Transaction ID">
          <InputGroup className="mt-2">
            <FormControl value={transactionId} readOnly />
            <Button variant="danger" onClick={handleOpen}>
              Create Chargeback
            </Button>
            <Confirm
              isLoading={isLoading}
              title="Create Chargeback Transaction"
              content={`Are you sure you want to create a chargeback record for external id ${externalId}, transaction id ${transactionId}?`}
              open={isCreateChargebackConfirm}
              onClose={handleClose}
              onYes={() => this.createChargebackTransaction()}
              onNo={handleClose}
            />
          </InputGroup>
        </FieldSet>
      </div>
    );
  };

  handleClose() {
    this.setState({
      show: false,
      isPdfLoading: false,
      pdf: null,
    });
  }

  handleShow() {
    this.setState({
      show: true,
      isPdfLoading: false,
      pdf: null,
    });
  }

  load(selectedTransaction) {
    const { emailAddress, } = this.state;
    this.setState({
      isPdfLoading: true,
      pdf: null,
    });
    TransactionService.generateChargebackReport(selectedTransaction.externalId, emailAddress)
      .then(response => response.data)
      .then((blob) => {
        this.setState({
          pdf: blob,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          isPdfLoading: false,
        });
      });
  }

  showForm() {
    return this.showChargebackTransactionForm();
  }

  createChargebackTransaction() {
    const {
      transactionId, externalId, version, serviceOfferingId,
    } = this.props;

    this.setState({
      isLoading: true,
    });

    BraintreePaymentService.createChargebackForTransaction(transactionId, version)
      .then(() => {
        this.setState({
          status: buildSuccessStatus(
            `A chargeback transaction record has been successfully created for transaction id ${transactionId}. Search by external ID ${externalId} to view the sale and chargeback records.`,
            () => this.onDismiss()
          ),
        });
      })
      .catch(() => {
        this.setState({
          status: buildFailureStatus(
            `Unable to create a chargeback record for transaction id ${transactionId}`,
            () => this.onDismiss()
          ),
        });
      })
      .finally(() => {
        if (serviceOfferingId !== 'gr_water') {
          this.setState({ isLoading: false, isCreateChargebackConfirm: false, });
        } else {
          this.setState({ isLoading: false, isCreateChargebackConfirm: false, }, () => {
            this.applyChargeback(transactionId, serviceOfferingId);
          });
        }
      });
  }

  applyChargeback(transactionId, serviceOfferingId) {
    TransactionService.getRefundTransactionsByTransactionId(transactionId)
      .then((response) => {
        const refunds = response.data.data;
        const chargebackArray = refunds.filter(
          transaction => transaction.transactionType === 'CHARGEBACK'
        );

        if (chargebackArray.length === 0) {
          this.setState({
            chargebackStatus: buildFailureStatus(
              `No chargeback found for transaction id ${transactionId}`,
              () => this.onDismiss()
            ),
          });
        } else {
          UtilitiesService.applyChargeback(chargebackArray[0]._id, serviceOfferingId)
            .then(() => {
              this.setState({
                chargebackStatus: buildSuccessStatus('Chargeback has been applied to bill.', () => this.onDismiss()),
              });
            })
            .catch(() => {
              this.setState({
                chargebackStatus: buildFailureStatus('Unable to apply chargeback to bill', () => this.onDismiss()),
              });
            });
        }
      })
      .catch(() => {
        this.setState({
          chargebackStatus: buildFailureStatus(`No records found for transaction id ${transactionId}`, () => this.onDismiss()),
        });
      });
  }

  render() {
    const { show, status, chargebackStatus, } = this.state;
    return (
      <div>
        <Button variant="primary" onClick={() => this.handleShow()}>
          Chargebacks
        </Button>
        <Modal show={show} onHide={() => this.handleClose()} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>Create Chargeback Transaction</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.showForm()}
            {status}
            {chargebackStatus}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

ChargebackTransactionForm.propTypes = {
  transactionId: PropTypes.string.isRequired,
  externalId: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
  serviceOfferingId: PropTypes.string.isRequired,
};
export default ChargebackTransactionForm;
